import React from 'react';

const Divider = ({ color, width, margin, alignment }) => {
    let marginLeft, marginRight;
    switch(alignment) {
        case 'left':
            marginLeft = '0';
            marginRight = 'auto';
            break;
        case 'right':
            marginLeft = 'auto';
            marginRight = '0';
            break;
        default:  // defaults to center alignment
            marginLeft = marginRight = 'auto';
    }

    const dividerStyle = {
        border: 'none',
        height: '10px',
        borderRadius: '5px',
        width: width,
        color: color,
        backgroundColor: color,
        margin: `${margin}px 0`,
        display: 'block',
        marginLeft: marginLeft,
        marginRight: marginRight
    };
    
    return <hr style={dividerStyle} />
}

export default Divider;
